// extracted by mini-css-extract-plugin
export default {"payment":"Ar","title_row":"Br","border_bottom":"Cr","promo_wrapper":"Er","payment_wrapper":"Fr","label":"Gr","card_row":"Hr","cardcontain":"Ir","card_input":"Jr","card_error":"Kr","card_label":"Lr","lock":"Mr","same_address":"Nr","place_order_button":"Or","buttonwrap":"Pr","hide_form":"Qr","paypal_buttons":"Rr","review_button":"Sr","alt_payment":"Tr"};
    if(module.hot) {
      // 1713969925848
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  